import React, { useState } from "react";
import "@fontsource/righteous";
import "./Aarvek.css";
import Contact from "./contact";
import Chat from "./temp";
import Chatbot from "./bot";


function Aarvek() {
  const [isOpen, setIsOpen] = useState(false);
  const [lang, setLang] = useState("en"); 

  //contacts
  

  // Translations JSON
  const translations = {
    en: {
      brand: "Aarvek Tech",
      nav: { services: "Services", about: "About", contact: "Contact" },
      hero: {
        title: "We Build AI-Powered IT Solutions",
        subtitle: "Web Development • AI/ML Models • SEO • Cloud Solutions",
        cta: "Get Started",
      },
      services: "Our Services",
      about: {
        title: "About Us",
        desc: "At Aarvek Tech, we combine innovation and technology to deliver cutting-edge IT solutions. Our mission is to empower businesses with AI-driven tools, scalable web platforms, and cloud-native applications.",
      },
      contact: {
        title: "Get in Touch",
        name: "Your Name",
        email: "Your Email",
        msg: "Your Message",
        send: "Send Message",
      },
      footer: "© 2025 Aarvek. All rights reserved.",
    },
    hi: {
      brand: "आरवेक टेक",
      nav: { services: "सेवाएँ", about: "हमारे बारे में", contact: "संपर्क करें" },
      hero: {
        title: "हम एआई-संचालित आईटी समाधान बनाते हैं",
        subtitle: "वेब डेवलपमेंट • एआई/एमएल मॉडल • एसईओ • क्लाउड सॉल्यूशन्स",
        cta: "शुरू करें",
      },
      services: "हमारी सेवाएँ",
      about: {
        title: "हमारे बारे में",
        desc: "आरवेक टेक में, हम नवाचार और प्रौद्योगिकी को मिलाकर अत्याधुनिक आईटी समाधान प्रदान करते हैं। हमारा मिशन व्यवसायों को एआई-आधारित उपकरणों, स्केलेबल वेब प्लेटफ़ॉर्म और क्लाउड-नेटिव एप्लिकेशन से सशक्त बनाना है।",
      },
      contact: {
        title: "संपर्क करें",
        name: "आपका नाम",
        email: "आपका ईमेल",
        msg: "आपका संदेश",
        send: "भेजें",
      },
      footer: "© 2025 आरवेक, सभी अधिकार सुरक्षित।",
    },
    fr: {
      brand: "Aarvek Tech",
      nav: { services: "Services", about: "À propos", contact: "Contact" },
      hero: {
        title: "Nous créons des solutions IT basées sur l'IA",
        subtitle: "Développement Web • Modèles IA/ML • SEO • Solutions Cloud",
        cta: "Commencer",
      },
      services: "Nos Services",
      about: {
        title: "À propos de nous",
        desc: "Chez Aarvek Tech, nous combinons innovation et technologie pour fournir des solutions IT de pointe. Notre mission est d'aider les entreprises grâce à des outils basés sur l'IA, des plateformes web évolutives et des applications cloud-native.",
      },
      contact: {
        title: "Contactez-nous",
        name: "Votre Nom",
        email: "Votre Email",
        msg: "Votre Message",
        send: "Envoyer",
      },
      footer: "© 2025 Aarvek Tous droits réservés.",
    },
    mr: {
      brand: "आरवेक टेक",
      nav: { services: "सेवा", about: "आमच्याबद्दल", contact: "संपर्क" },
      hero: {
        title: "आम्ही एआय-चालित आयटी सोल्यूशन्स तयार करतो",
        subtitle: "वेब डेव्हलपमेंट • एआय/एमएल मॉडेल • एसईओ • क्लाउड सोल्यूशन्स",
        cta: "सुरू करा",
      },
      services: "आमच्या सेवा",
      about: {
        title: "आमच्याबद्दल",
        desc: "आरवेक टेक मध्ये, आम्ही नवनिर्मिती आणि तंत्रज्ञान एकत्र आणून अत्याधुनिक आयटी सोल्यूशन्स प्रदान करतो. आमचे उद्दिष्ट व्यवसायांना एआय-आधारित साधने, स्केलेबल वेब प्लॅटफॉर्म आणि क्लाउड-नेटिव्ह अँप्लिकेशनद्वारे  सक्षम करणे आहे.",
      },
      contact: {
        title: "संपर्क",
        name: "तुमचे नाव",
        email: "तुमचा ईमेल",
        msg: "तुमचा संदेश",
        send: "पाठवा",
      },
      footer: "© 2025 आरवेक टेक. सर्व हक्क राखीव.",
    },
  };

  const t = translations[lang];

  const services = [
    { title: "Web Development", points: ["Responsive Design", "E-commerce Solutions", "Custom Web Apps"] },
    { title: "AI/ML Solutions", points: ["Predictive Analytics", "Chatbots & NLP", "Model Deployment"] },
    { title: "SEO & Digital Marketing", points: ["On-page & Off-page SEO", "Social Media Marketing", "Ad Campaigns"] },
    { title: "Mobile App Development", points: ["iOS & Android Apps", "Cross-platform Solutions", "UI/UX Optimization"] },
    { title: "Cloud Hosting", points: ["Scalable Infrastructure", "Secure Storage", "24/7 Support"] },
    { title: "Chatbot Development", points: ["AI-Powered Bots", "Multilingual Support", "Customer Engagement"] },
  ];

  return (
    <div className="aarvek">
<nav className="navbar">
  {/* Brand */}
  <div className="navbar-left">
    <a href="#home" className="brand">
      <span className="brand-orange">AA</span>
      <span className="brand-black">RVEK</span>
    </a>
  </div>

  {/* Right section */}
  <div className="navbar-right">
    {/* Hamburger for mobile */}
    <button className="menu-btn" onClick={() => setIsOpen(!isOpen)}>
      ☰
    </button>

    {/* Nav links */}
    <ul className={`menu ${isOpen ? "open" : ""}`}>
      <li><a href="#services" onClick={() => setIsOpen(false)}>{t.nav.services}</a></li>
      <li><a href="#about" onClick={() => setIsOpen(false)}>{t.nav.about}</a></li>
      <li><a href="#contact" onClick={() => setIsOpen(false)}>{t.nav.contact}</a></li>
    </ul>

    {/* Language selector (always visible) */}
    <select
      className="lang-btn"
      value={lang}
      onChange={(e) => setLang(e.target.value)}
    >
      <option value="en">EN</option>
      <option value="hi">हिंदी</option>
      <option value="fr">FR</option>
      <option value="mr">मराठी</option>
    </select>
  </div>
</nav>


      {/* Hero Section */}
      <section className="hero">
        <h2>{t.hero.title}</h2>
        <p>{t.hero.subtitle}</p>
        <a href="#contact" className="cta">{t.hero.cta}</a>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <h3>{t.services}</h3>
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.title} className="service-card">
              <h4>{service.title}</h4>
              <ul>
                {service.points.map((point, i) => <li key={i}>{point}</li>)}
              </ul>
              <a href="#contact" className="btn">{t.hero.cta}</a>
            </div>
          ))}
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <h3>{t.about.title}</h3>
        <p>{t.about.desc}</p>
      </section>
     
      {/* Contact Section */}
      <Contact t={t} />

      

      {/* Footer */}
      <footer className="footer">
        <p>{t.footer}</p>
      </footer>
      
    <Chat/>
    
    </div>
  );
}

export default Aarvek;
